(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.nv-product-chapter-mobile a');
  if (link) link.closest('details').open = false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-catalog-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nv-model-video')) {
  customElements.define('nv-model-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('button')?.addEventListener('click', () => {
        const template = this.querySelector('template');
        if (!template) return;
        this.append(template.content.cloneNode(true));
        this.querySelector('button')?.remove();
        this.querySelector('iframe')?.focus();
      }, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-home-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nyvolt-home-carousel')) {
  customElements.define('nyvolt-home-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.nvc-slide'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.inView = false;
      this.hovered = false;
      this.focused = false;
      this.events = new AbortController();
      const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, {...options, signal:this.events.signal});
      this.querySelector('.nvc-controls').hidden = false;
      on(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1, true));
      on(this.querySelector('[data-previous]'), 'click', () => this.show(this.index - 1, true));
      on(this.querySelector('[data-toggle]'), 'click', () => { this.paused = !this.paused; if (!this.paused) { this.focused = false; this.hovered = false; } this.updatePause(); this.schedule(); });
      this.querySelectorAll('[data-slide-to]').forEach(button => on(button, 'click', () => this.show(Number(button.dataset.slideTo), true)));
      on(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } });
      on(this, 'keydown', event => {
        if (event.target.closest('input, textarea, select') || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true); }
      });
      const stage = this.querySelector('.nvc-stage');
      on(stage, 'pointerdown', event => { this.swiped = false; if (event.pointerType === 'touch') this.touch = {x:event.clientX, y:event.clientY}; }, {passive:true});
      on(stage, 'pointerup', event => {
        if (!this.touch) return;
        const x = event.clientX - this.touch.x, y = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.4) { this.swiped = true; this.show(this.index + (x < 0 ? 1 : -1), true); }
      }, {passive:true});
      on(stage, 'click', event => { if (this.swiped) { event.preventDefault(); this.swiped = false; } }, {capture:true});
      on(stage, 'pointercancel', () => { this.touch = null; });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.reduced, 'change', event => { if (event.matches) { this.paused = true; this.updatePause(); this.schedule(); } });
      on(document, 'shopify:block:select', event => { const slide = event.target.closest('.nvc-slide'); if (slide && this.contains(slide)) this.show(this.slides.indexOf(slide), true); });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, {threshold:0.2});
        this.observer.observe(this);
      } else { this.inView = true; }
      this.updatePause();
      this.schedule();
    }
    show(next, manual = false) {
      this.index = (next + this.slides.length) % this.slides.length;
      if (manual) this.paused = true;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        if (active) slide.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      });
      this.querySelectorAll('[data-slide-to]').forEach((button, index) => {
        if (index === this.index) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current');
      });
      this.querySelector('[data-current]').textContent = String(this.index + 1).padStart(2, '0');
      this.querySelector('[data-current-title]').textContent = this.slides[this.index].dataset.title;
      if (manual) this.querySelector('[data-announcement]').textContent = this.slides[this.index].getAttribute('aria-label');
      this.updatePause();
      this.schedule();
    }
    updatePause() {
      this.classList.toggle('is-paused', this.paused);
      this.querySelector('[data-toggle]').setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || !this.inView || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nyvolt-range')) {
  customElements.define('nyvolt-range',class extends HTMLElement {
    connectedCallback(){
      if(this.dataset.ready)return;
      this.dataset.ready='true';
      const controls=this.querySelector('.nr-range__filters');
      if(!controls)return;
      controls.hidden=false;
      const cards=Array.from(this.querySelectorAll('.nr-card'));
      controls.addEventListener('click',event=>{
        const button=event.target.closest('[data-brand-filter]');
        if(!button)return;
        const brand=button.dataset.brandFilter;
        let count=0;
        cards.forEach(card=>{card.hidden=brand!=='all'&&card.dataset.brand!==brand;if(!card.hidden){count++;card.classList.add('nv-visible');card.style.setProperty('--nv-delay','0ms');}});
        controls.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
        const few=this.ownerDocument.documentElement.lang.startsWith('pl')&&count%10>=2&&count%10<=4&&!(count%100>=12&&count%100<=14);
        this.querySelector('[data-range-count]').textContent=count+' '+(count===1?this.dataset.countOne:few?this.dataset.countFew:this.dataset.countMany);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ryvolt-modeles"] && !Shopify.designMode) return;
  try {
    
function initRyvoltRange(root){
  const ranges=root.matches?.('[data-rv-range]')?[root]:root.querySelectorAll('[data-rv-range]');
  ranges.forEach((range)=>{
    if(range.dataset.rvReady)return;range.dataset.rvReady='true';
    const tablist=range.querySelector('[data-rv-tabs]');const tabs=Array.from(range.querySelectorAll('[data-rv-tab]'));const panels=Array.from(range.querySelectorAll('[data-rv-panel]'));
    if(!tabs.length)return;
    const select=(key,focus=false)=>{
      tabs.forEach((tab)=>{const active=tab.dataset.rvTab===key;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;if(active&&focus)tab.focus()});
      panels.forEach((panel)=>{panel.hidden=panel.dataset.rvPanel!==key;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tabs.find((tab)=>tab.dataset.rvTab===panel.dataset.rvPanel).id)});
    };
    tablist.hidden=false;select(tabs[0].dataset.rvTab);
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>select(tab.dataset.rvTab));
      tab.addEventListener('keydown',(event)=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(tabs[next].dataset.rvTab,true)});
    });
    range.addEventListener('shopify:block:select',(event)=>{if(event.detail?.blockId)select(event.detail.blockId)});
  });
}
initRyvoltRange(document);
document.addEventListener('shopify:section:load',(event)=>initRyvoltRange(event.target));

  } catch(e) { console.error(e); }
})();
})();
